import React from 'react'
import s from './index.module.scss'
import classNames from 'classnames'
import Portal from '../../Portal'

interface IProps {
	closeHandler?: () => void
	isAnimate?: boolean
	children?: React.ReactNode
}

const ModalWrapper = ({ closeHandler, isAnimate, children }: IProps) => {
	return (
		<Portal>
			<div
				className={classNames(s.wrapper, {
					[s.animate]: isAnimate,
				})}
				onClick={closeHandler}
			/>
			{children}
		</Portal>
	)
}

export default ModalWrapper
